import React, { type ReactNode } from "react";
import { Section, type SectionProps } from "components/section";
import { PaginatedSlider } from "ui/slider";
import { Quote } from "./quote";

const defaultSlides = [
  <Quote
    key="ramp"
    isInSlider
    quote="This might be one of the greatest inventions for technical marketers since the advent of legacy CDPs back in 2015."
    author="Austin Hay"
    authorImage="https://cdn.sanity.io/images/pwmfmi47/production/44f07bf1d78bb245037a5b0b942bf9e6bfac3cb4-816x720.png"
    job="Head of Marketing Technology"
    company="Ramp"
    logo="https://cdn.sanity.io/images/pwmfmi47/production/acaf90882a1ded8a3796cc3972219355a42d009c-270x72.svg"
    href="/customers/ramp"
  />,
  <Quote
    key="petsmart"
    isInSlider
    quote="We have to do things great for millions of customers every single day. We have to have technology to help power that. That’s what we’re getting from the Hightouch and Snowflake ecosystem."
    author="Bradley Breuer"
    authorImage="https://cdn.sanity.io/images/pwmfmi47/production/e9311933262cd43496a2980e6252e753d10e9181-816x720.png"
    job="VP Marketing"
    company="PetSmart"
    logo="https://cdn.sanity.io/images/pwmfmi47/production/375df10710b9b2fbd2cf9c2ae5f669672753022d-607x150.png"
    href="https://www.youtube.com/watch?v=j-d7yeSZJlQ"
  />,
  <Quote
    key="wmg"
    isInSlider
    quote="The combination of Snowflake and Hightouch forms the cornerstone of our customer intelligence platform."
    author="Tom Dinneny"
    authorImage="https://cdn.sanity.io/images/pwmfmi47/production/f8c7c3f27e32a970b2a10ca07f68f2b452517a22-816x720.png"
    job="Customer Intelligence Platform Director"
    company="Warner Music Group"
    logo="https://cdn.sanity.io/images/pwmfmi47/production/84dbb616e064de970801b02e16e419d60fcd4b44-2560x1009.png"
    href="/customers/wmg"
  />,
];

export function QuoteSlider({ slides = defaultSlides, ...props }: { slides?: ReactNode[] } & SectionProps) {
  return (
    <Section fullWidth {...props}>
      <PaginatedSlider slides={slides} />
    </Section>
  );
}
